import { Redirect, useLocation } from 'react-router';

export const RemoveSlash = () => {
  const { pathname } = useLocation();

  if (pathname.match('/.*/$')) {
    return <Redirect exact to={pathname.replace(/\/+$/, '')} />;
  }
};
